/* eslint-disable no-restricted-imports */
import { Ribbon } from '@/data/types/Product';

export const excludeRibbons = ['DPS_', 'DPD_', 'DPV_', 'DPT_'];

export const isExcludeRibbon = (identifier: string) =>
	excludeRibbons.some((ribbon) => identifier.startsWith(ribbon));

export const mergeRibbonsForProduct = (ribbons: Ribbon[]) => {
	const dpdSapNuevo = ribbons.filter((item) => item.identifier === 'DPD_SAPNuevo');
	const sortedRibbons = [...dpdSapNuevo];

	const uniqueRibbons = sortedRibbons.filter(
		(ribbon, index, self) => index === self.findIndex((t) => t.value === ribbon.value)
	);

	return uniqueRibbons;
};
